export function formatSecondToMinutes(seconds) {
    if (seconds) {
      var minute = Math.floor((seconds / 60) % 60);
      minute = minute < 10 ? '0' + minute : minute;
      var second = seconds % 60;
      second = second < 10 ? '0' + second : second;
      return minute + ':' + second;
    } else {
      return '00:00';
    }
  }
  /**
   *  Este método recibe una cadena numerica, retorna la
   *  cadena con formato de moneda local CLP.
   */
  export const agregarformatoPesos = (numero) => {
    try {
      return `$${formatThousandsSeparators(numero)}`
    } catch (error) {
      return ''    
    }
  }

  export const formatRut = (rut) => {
    if(rut){
      let clearRut = rut.toLocaleLowerCase().replace(/[^\dk]/g, '');
    
      if (clearRut.length > 1) {
        const lastDigit = clearRut.slice(-1);
        const formattedRut = clearRut.slice(0, -1).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    
        clearRut = `${formattedRut}-${lastDigit}`;
      }
      
  
    return clearRut;
    }
  };

  export function formatThousandsSeparators(word) {
    try {
      var formatePuntos = word
        .toString()
        .replace(/\./g, '')
        .replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      var formateThousandsSeparators = formatePuntos;
      return formateThousandsSeparators;
    } catch (error) {
      return '';
    }
  }


  export const ocultarDatosTarjeta = (numerotarjeta) => {
    const tajetaParseStrin=`${numerotarjeta}`;
    const newTarjeta = tajetaParseStrin.split('');
    newTarjeta.splice(0,12,"X","X","X","X",' ',"X","X","X","X" ,' ',"X","X","X","X", ' ');
    return newTarjeta.toString().replace(/,/g,"");
  
}
